// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reader-content.reader-content{padding:60px 100px 60px 100px;display:block;margin:0 auto;max-width:800px}@media (max-width: 900px){.reader-content.reader-content{padding:40px 20px 40px 20px}}\n", ""]);
// Exports
module.exports = exports;
